// extracted by mini-css-extract-plugin
export default {"app":"App_app__GQ97N","header":"App_header__vtMpi","content":"App_content__i-RuO","footer":"App_footer__tPRoB"};